import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HomeSchemaOrg from '@/components/base/HomeSchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedPlatforms from './components/FeaturedPlatforms';
import CategoryOverview from './components/CategoryOverview';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <HomeSchemaOrg />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedPlatforms />
        <CategoryOverview />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}